<template>
	<mt-header fixed :title="headerTitle">
		<div slot="left">
			<mt-button icon="back" v-show="BackisShow" @click="goToBack"></mt-button>
			 <mt-button v-show="closeIsShow" @click="goToBack">关闭</mt-button>
		</div>
	</mt-header>
</template>

<script>
	/* Vue.prototype.$setgoindex = function () {
	  if (window.history.length <= 1) {
		if (location.href.indexOf('?') === -1) {
		  window.location.href = location.href + '?goindex=true'
		} else if (location.href.indexOf('?') !== -1 && location.href.indexOf('goindex') === -1) {
		  window.location.href = location.href + '&goindex=true'
		}
	  }
	} */
	 export default {
        name: "WcHeader",
        props:['headerTitle','BackisShow','closeIsShow'],
        data() {
        	return {
			}
        },
        mounted:function(){
        	//this.schema.prop='label'
			
        },
        beforeUpdate() {;
		    // 避免初始化之前产生事件
		},
		methods:{
			goToBack(){
				let routeName=this.$route.name
				if(routeName=='detailWorksheet'){
					var url='/worksheet?selected='+this.$route.query.selected;
					if(this.$route.query.ip){
						url+="&deviceIp="+this.$route.query.ip
					}else{
						url='/index/worksheet?selected='+this.$route.query.selected
					}
					if(this.$route.query.name){
						url+="&name="+this.$route.query.name
					}
					if(this.$route.query.str){
						url+='&str='+this.$route.query.str
					}
					this.$router.push(url)
				}else if(routeName=='monitor'){
					this.$router.push('/index')
				}else if(routeName=='worksheet'){
					url='/device';
					if(this.$route.query.str){
						url+='?str='+this.$route.query.str
					}
					this.$router.push(url)
				}else if(routeName=='device'){
					this.$router.push('/index')
				}else{
					window.history.length>1?this.$router.go(-1):this.$router.push('/');
				}
				
				//window.location.history.go(-1)
			}
		},
		activated: function () {
			//this.$setgoindex()
		}
    }
</script>

<style scoped="scoped">
	.mint-header{
		background-image: -webkit-linear-gradient(left,#00B5C0,#019BCD);
		background-image: linear-gradient(left,#00B5C0,#019BCD);
		height: 45px;
	}
	.mint-header.is-fixed{
		z-index: 999;
	}
	.mint-header{
		font-size: 16px;
	}
	.mint-header .mint-button{
		font-size: 13px;
	}
</style>


// WEBPACK FOOTER //
// src/components/header/WcHeader.vue